import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});


export class PickAndGoRulesFetchAPI {

    //Function to get pick and go rules 
    static async getPickAndGoRules(business_id, token) {
        const res = await server(`/pick-and-go?business_id=${business_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined
        });
        return res;
    }

    //Function to get every product asigned to a pick and go rule
    static async getPickAndGoRuleProducts(pick_and_go_id, token) {
        const res = await server(`/pickngo/rules/${pick_and_go_id}/products`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }
}